import { SavedModelPortfoliosState } from './saved-model-portfolios.interfaces';

export const savedModelPortfoliosInitialState: SavedModelPortfoliosState = {
	savedPortfolioMapping: new Map<string, string>()
};
